module.exports = __webpack_public_path__ + "static/Nudista-BoldItalic-167fb5ca065a7cdb285eb0e2423290f6.ttf";